/* Quick view: fetch product through the Section Rendering API and open the modal. */
(() => {
  if (window.__nsQuickView) return;
  window.__nsQuickView = true;
  const cache = new Map();
  document.addEventListener('click', async (e) => {
    const trigger = e.target.closest('[data-quick-view]');
    const thumb = e.target.closest('[data-qv-thumb]');
    if (thumb) {
      const rail = thumb.closest('.qv').querySelector('.qv__rail');
      rail.scrollTo({ left: rail.clientWidth * Number(thumb.dataset.qvThumb), behavior: 'smooth' });
      return;
    }
    if (!trigger) return;
    e.preventDefault();
    const modal = document.getElementById('QuickView');
    const target = modal.querySelector('[data-quick-view-target]');
    const skeleton = target.dataset.skeleton || (target.dataset.skeleton = target.innerHTML);
    target.innerHTML = skeleton;
    NS.open(modal, trigger);
    const url = trigger.dataset.quickView.split('?')[0] + '?section_id=quick-view';
    try {
      const html = cache.get(url) || await fetch(url).then((r) => r.text());
      cache.set(url, html);
      const content = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-quick-view-content]');
      target.innerHTML = content ? content.innerHTML : '';
      modal.setAttribute('aria-labelledby', 'QuickViewTitle');
      document.dispatchEvent(new CustomEvent('ns:dom-updated', { detail: target }));
      target.querySelector('input:not([type=hidden]), button')?.focus({ preventScroll: true });
    } catch { target.innerHTML = ''; NS.close(modal); location.href = trigger.dataset.quickView; }
  });
})();
